<div class="slider">
  @if (!minPosition) {
    <button class="slider__arrow slider__arrow--prev" type="button" (click)="move('prev')">
      <app-icon [icon]="'chevron'" [width]="24" [rotate]="180">{{ 'globals.prev' | translate }}</app-icon>
    </button>
  }
  <div #sliderContent class="slider__content" (scroll)="move()" (panstart)="panStart()" (pan)="pan($event)" (panend)="panEnd()">
    <div class="slider__main" [ngClass]="{ 'slider__main--padding': padding, 'slider__main--prevent-click': preventClick, }" [style]="'--slider-item-width: ' + itemWidth + 'px'" [style.gap.px]="gap">
      <ng-content></ng-content>
    </div>
  </div>
  @if (!maxPosition) {
    <button class="slider__arrow slider__arrow--next" type="button" (click)="move('next')">
      <app-icon [icon]="'chevron'" [width]="24">{{ 'globals.next' | translate }}</app-icon>
    </button>
  }
</div>
